import { useEffect } from "react";
import styles from "../styles/_components/sidePanel.module.scss";

const SidePanel = ({ children, setIsOpen, title }) => {
  // Close on Escape key
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") setIsOpen && setIsOpen(false);
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  // Prevent body scroll while open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  return (
    <div className={styles.root}>
      {/* Backdrop */}
      <div
        className={styles.backdrop}
        onClick={() => setIsOpen && setIsOpen(false)}
      />

      {/* Panel */}
      <div className={styles.panel}>
        {/* Header */}
        <div className={styles.header}>
          {title && <span className={styles.title}>{title}</span>}
          <button
            className={styles.closeBtn}
            onClick={() => setIsOpen && setIsOpen(false)}
            aria-label="סגור"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default SidePanel;
